import { Heading, Stack, Text } from '@etg/wings';
import { useTranslation } from '@eti/providers';
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
const SeatMapHeader = _ref => {
  let {
    from,
    to,
    currentSegmentIndex,
    totalSegmentsCount,
    currentSegmentData
  } = _ref;
  const {
    t
  } = useTranslation();
  const segmentDescriptionText = currentSegmentData && currentSegmentIndex ? t('Seating.Segments.Details.Description', currentSegmentIndex, totalSegmentsCount, currentSegmentData.from.iata, currentSegmentData.to.iata) : '';
  return /*#__PURE__*/_jsxs(Stack, {
    children: [/*#__PURE__*/_jsxs(Heading, {
      "data-testid": "seatMap-header",
      level: 3,
      children: [from, " \u2013 ", to]
    }), /*#__PURE__*/_jsx(Text, {
      "data-testid": "seatMap-segments-text",
      children: segmentDescriptionText
    })]
  });
};
export default SeatMapHeader;
//# sourceMappingURL=SeatMapHeader.js.map